// extracted by mini-css-extract-plugin
module.exports = {"goUp":"Counter_goUp__3DbIH","waitDown":"Counter_waitDown__25bqV","initial":"Counter_initial__28rzw"};